import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationDemographicConfigsAlreadyExistsError =
  BaseErrorSchema.extend({
    errorType: z.literal('OrganizationDemographicConfigsAlreadyExistsError'),
  });

export type OrganizationDemographicConfigsAlreadyExistsError = z.infer<
  typeof OrganizationDemographicConfigsAlreadyExistsError
>;
